import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './Layout.scss';
/**
 * @component Layout
 * @since 1.0.0
 */
export function Layout(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const className = classNames('layout', 'layout--' + style, props.className);
    return React.createElement("div", { className: className }, props.children);
}
